import React, { useState, memo } from "react";
import PropTypes from "prop-types";
import { Grid, IconButton, Typography, TextField } from "@mui/material";
import { Remove as RemoveIcon, Add as AddIcon } from "@mui/icons-material";
import "./ListItems.css";
import { useDispatch, useSelector } from "react-redux";
import {
  add_product_action,
  remove_product_action,
  set_amount_product_action,
} from "../../../redux/actions/cart";
import LowStock from "../../Dialogs/LowStock/LowStock";

const ListItems = (props) => {
  const { data, cartInfo, setSelectedItem, setOpenItemDialog, storeAddons } =
    props;

  const customerStore = useSelector((state) => state.customer);

  const [action, setAction] = useState("");
  const [cQty, setCQty] = useState(0);
  const [unitType, setUnitType] = useState("");
  const [displayLowStock, setDisplayLowStock] = useState(false);
  const [displayLowStockClosePerm, setDisplayLowStockClosePerm] =
    useState(false);

  const dispatch = useDispatch();

  const add = () => {
    dispatch(add_product_action(data, customerStore, true));
  };

  const substract = () => {
    if (cartInfo && cartInfo.unit_in_cart > 0) {
      dispatch(remove_product_action(data, customerStore, true));
    }
  };

  const addCase = () => {
    dispatch(add_product_action(data, customerStore, false));
  };

  const substractCase = () => {
    if (cartInfo && cartInfo.case_in_cart > 0) {
      dispatch(remove_product_action(data, customerStore, false));
    }
  };

  const handleAmountChange = (e) => {
    const { name, value } = e.target;

    const amount = value === "" ? 0 : value;

    dispatch(
      set_amount_product_action(
        data,
        customerStore,
        amount,
        name === "unit_in_cart"
      )
    );
  };

  const handleOpenItemDialog = () => {
    setSelectedItem(data);
    setOpenItemDialog(true);
  };

  const handleLowStock = (actionFired, unitType = "", currentQty) => {
    setAction(actionFired);
    setCQty(currentQty);
    setUnitType(unitType);
    setDisplayLowStock(true);
  };

  const resetLowStock = () => {
    setAction("");
    setCQty(0);
    setUnitType("");
    setDisplayLowStock(false);
    setDisplayLowStockClosePerm(true);
  };

  const handleDisplaySubs = () => {
    setDisplayLowStock(false);
  };

  return (
    <>
      <LowStock
        data={data}
        action={action}
        unitType={unitType}
        cQty={cQty}
        display={displayLowStock}
        add={add}
        addCase={addCase}
        substract={substract}
        substractCase={substractCase}
        handleAmountChange={handleAmountChange}
        resetLowStock={resetLowStock}
        handleDisplaySubs={handleDisplaySubs}
      />
      <Grid
        container
        spacing={1}
        alignItems="center"
        className={data.active === false ? "iInactive" : ""}
      >
        <Grid item xs={true}>
          <Typography
            variant="body2"
            color="text.secondary"
            align="left"
            onClick={handleOpenItemDialog}
          >
            {data.name}
          </Typography>
        </Grid>
        <Grid item xs={data.display_unit_price > 0 ? 4 : "auto"} sm={2}>
          {data.display_unit_price > 0 ? (
            <Grid container alignItems="center">
              <Grid item xs={12}>
                <Typography align="center" className="typographyPriceUnitMob">
                  ${data.display_unit_price}
                  <span style={{ fontWeight: 900 }}> UNIT</span>
                </Typography>

                {data.display_unit_price_per_lb ? (
                  <Typography
                    align="center"
                    className="typographyPricePerLbUnitMob"
                  >
                    Price per lb:
                    {data.display_unit_price_per_lb
                      ? " $" + data.display_unit_price_per_lb
                      : " N/A"}
                  </Typography>
                ) : (
                  <></>
                )}
              </Grid>
              {storeAddons ? (
                <>
                  <Grid item xs="auto">
                    <IconButton
                      onClick={() =>
                        (data.stock_level_indicator === "low stock" ||
                          data.combined_stock_level === null) &&
                        !displayLowStockClosePerm
                          ? handleLowStock("substract")
                          : substract()
                      }
                      style={{ padding: 0 }}
                    >
                      <RemoveIcon color="error" />
                    </IconButton>
                  </Grid>
                  <Grid item xs={true}>
                    <TextField
                      fullWidth
                      size="small"
                      variant="standard"
                      name="unit_in_cart"
                      value={cartInfo ? cartInfo.unit_in_cart : 0}
                      onChange={(e) =>
                        (data.stock_level_indicator === "low stock" ||
                          data.combined_stock_level === null) &&
                        !displayLowStockClosePerm
                          ? handleLowStock(
                              "amount",
                              "unit_in_cart",
                              cartInfo ? cartInfo.unit_in_cart : 0
                            )
                          : handleAmountChange(e)
                      }
                      inputProps={{ style: { textAlign: "center" } }}
                    />
                  </Grid>
                  <Grid item xs="auto">
                    <IconButton
                      onClick={() =>
                        (data.stock_level_indicator === "low stock" ||
                          data.combined_stock_level === null) &&
                        !displayLowStockClosePerm
                          ? handleLowStock("add")
                          : add()
                      }
                      style={{ padding: 0 }}
                    >
                      <AddIcon color="success" />
                    </IconButton>
                  </Grid>
                </>
              ) : (
                <></>
              )}
            </Grid>
          ) : (
            <></>
          )}
        </Grid>
        <Grid item xs={4} sm={2}>
          {data.display_case_price > 0 ? (
            <Grid container alignItems="center">
              <Grid item xs={12}>
                <Typography align="center" className="typographyPriceCaseMob">
                  ${data.display_case_price} ({data.units_per_case})
                  <span style={{ fontWeight: 900 }}> CASE</span>
                </Typography>
                {data.display_case_price_per_lb ? (
                  <Typography
                    align="center"
                    className="typographyPricePerLbCaseMob"
                  >
                    Price per lb:
                    {data.display_case_price_per_lb
                      ? " $" + data.display_case_price_per_lb
                      : " N/A"}
                  </Typography>
                ) : (
                  <></>
                )}
              </Grid>
              {storeAddons ? (
                <>
                  <Grid item xs="auto">
                    <IconButton
                      onClick={() =>
                        (data.stock_level_indicator === "low stock" ||
                          data.combined_stock_level === null) &&
                        !displayLowStockClosePerm
                          ? handleLowStock("substractCase")
                          : substractCase()
                      }
                      style={{ padding: 0 }}
                    >
                      <RemoveIcon color="error" />
                    </IconButton>
                  </Grid>
                  <Grid item xs={true}>
                    <TextField
                      fullWidth
                      size="small"
                      variant="standard"
                      name="case_in_cart"
                      value={cartInfo ? cartInfo.case_in_cart : 0}
                      onChange={(e) =>
                        (data.stock_level_indicator === "low stock" ||
                          data.combined_stock_level === null) &&
                        !displayLowStockClosePerm
                          ? handleLowStock(
                              "amount",
                              "case_in_cart",
                              cartInfo ? cartInfo.case_in_cart : 0
                            )
                          : handleAmountChange(e)
                      }
                      inputProps={{ style: { textAlign: "center" } }}
                    />
                  </Grid>
                  <Grid item xs="auto">
                    <IconButton
                      onClick={() =>
                        (data.stock_level_indicator === "low stock" ||
                          data.combined_stock_level === null) &&
                        !displayLowStockClosePerm
                          ? handleLowStock("addCase")
                          : addCase()
                      }
                      style={{ padding: 0 }}
                    >
                      <AddIcon color="success" />
                    </IconButton>
                  </Grid>
                </>
              ) : (
                <></>
              )}
            </Grid>
          ) : (
            <></>
          )}
        </Grid>
      </Grid>
    </>
  );
};

ListItems.propTypes = {
  data: PropTypes.shape({
    name: PropTypes.string.isRequired,
  }).isRequired,
};

export default memo(ListItems, (prev, next) => {
  return prev.cartInfo || next.cartInfo ? false : true;
});
